export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export const validatePassword = (password) => password != null && typeof password == "string" && password.length > 4

const passwordTest = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W])[A-Za-z\d\W\_\ ]{8,}$/

export const validateComplexPassword = (password) => password && password !== "" && passwordTest.test(password)

const usernameTest = /^[a-zA-Z0-9-_.]+$/

const isUsernameValid = (username) => username && usernameTest.test(username)

const isUsernameTooShort = (username) => username && username.length < 5

const isUsernameTooLong = (username) => username && username.length >= 64

export const validateMinorsUsername = (username) => isUsernameValid(username) && !isUsernameTooShort(username) && !isUsernameTooLong(username)

export const validateUsername = (username) => (isUsernameValid(username) || validateEmail(username)) && !isUsernameTooShort(username) && !isUsernameTooLong(username)
